import { openBlock as t, createElementBlock as o, createElementVNode as c } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, l = /* @__PURE__ */ c("path", {
  fill: "currentColor",
  d: "M10.125 16.125A.63.63 0 0 1 9.5 15.5v-1.75a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v1.75a.63.63 0 0 1-.625.625"
}, null, -1), n = /* @__PURE__ */ c("path", {
  fill: "currentColor",
  d: "M14.917 18.958H5.334V17.5a2.29 2.29 0 0 1 2.291-2.292h5a2.29 2.29 0 0 1 2.292 2.292zm-8.333-1.25h7.083V17.5c0-.575-.467-1.042-1.042-1.042h-5c-.575 0-1.041.467-1.041 1.042z"
}, null, -1), a = /* @__PURE__ */ c("path", {
  fill: "currentColor",
  d: "M15.125 18.958h-10a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h10a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625m.233-8.591a.64.64 0 0 1-.475-.217.62.62 0 0 1-.1-.658c.283-.65.425-1.342.425-2.067v-2.5c0-.292-.05-.575-.15-.875l-.025-.092A2 2 0 0 1 15 3.592a.63.63 0 0 1 .625-.625h.5c1.491 0 2.708 1.25 2.708 2.791A4.9 4.9 0 0 1 17.4 9.2c-.017.017-.067.058-.075.067-.492.408-1.05.866-1.8 1.075a.6.6 0 0 1-.167.025M16.4 4.242c.041.225.058.458.058.683v2.5c0 .342-.025.667-.075 1l.142-.117a3.64 3.64 0 0 0 1.058-2.55c0-.75-.508-1.383-1.183-1.516M4.65 10.333a.5.5 0 0 1-.192-.033A4.64 4.64 0 0 1 2.6 9.15c-.96-1.058-1.433-2.217-1.433-3.442A2.68 2.68 0 0 1 3.875 3h.542a.623.623 0 0 1 .575.875c-.134.3-.2.642-.2 1v2.5c0 .717.141 1.417.433 2.083a.63.63 0 0 1-.108.667.64.64 0 0 1-.467.208M3.583 4.275a1.444 1.444 0 0 0-1.166 1.433c0 .909.366 1.784 1.091 2.584a.7.7 0 0 0 .117.108 6 6 0 0 1-.083-1.025v-2.5q.002-.3.041-.6"
}, null, -1), r = /* @__PURE__ */ c("path", {
  fill: "currentColor",
  d: "M10 13.958c-3.559 0-6.458-2.9-6.458-6.458V5A3.96 3.96 0 0 1 7.5 1.042h5A3.96 3.96 0 0 1 16.458 5v2.5c0 3.558-2.9 6.458-6.458 6.458M7.5 2.292A2.714 2.714 0 0 0 4.792 5v2.5A5.21 5.21 0 0 0 10 12.708 5.21 5.21 0 0 0 15.208 7.5V5A2.714 2.714 0 0 0 12.5 2.292z"
}, null, -1), h = [
  l,
  n,
  a,
  r
];
function s(d, i) {
  return t(), o("svg", e, [...h]);
}
const u = { render: s };
export {
  u as default,
  s as render
};
